import { createUseStyles } from "react-jss";

export const ManagementDockLedDisplayContainerStyle = createUseStyles((theme: any) => ({
    generalContainer: {
        display: "flex",
        height: "100vh",
        width: "100%",
        overflow: "hidden",
        backgroundColor: "black",
    },
    waiting: {
        width: "55%",
        height: "100%",
        overflow: "hidden",
    },
    assigned: {
        width: "45%",
        height: "100%",
        overflow: "hidden",
    },
    header: {
        backgroundColor: theme.colors.palette.black,
        color: theme.colors.palette.white,
        height: 41,
        display: "flex",
        alignItems: "center",
        textTransform: "uppercase",
        fontSize: "14px !important",
        fontWeight: theme.fonts.weight.bold,
        width: "100%",
        justifyContent: "center",
    },
    dataGrid:{
        padding: theme.paddings.sizes.base,
        overflow: "hidden",
    },
    data: {
        overflow: "hidden",
        display: "flex",
        gap: "7px",
        flexDirection: "column",
        alignContent: "center",
        alignItems: "center",
        paddingTop: theme.paddings.sizes.base,
    },
    timer: {
        fontSize: theme.fonts.sizes.xxl,
    },
    leyend: {
        justifyContent: "center",
        width: "100%",
        color: theme.colors.site.color,
        fontWeight: theme.fonts.weight.normal,
    }
}));
